<template>
  <div>
    <v-select
      dense
      outlined
      :clearable="true"
      :error-messages="erroMessage"
      :loading="isLoading"
      :items="items"
      item-value="id"
      item-text="name"
      :label="label ? label : 'Operadora'"
      @change="onChange"
      :disabled="isLoading || disabled"
    >
      <template v-slot:item="{active, item, attrs, on}">
        <v-list-item v-on="on" v-bind="attrs" #default="{active}" :class="highlightClass(item)">
          <v-list-item-content>
            <v-list-item-title>
              <v-row no-gutters align="center">
                <span>{{ item.name }}</span>
              </v-row>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-select>
  </div>
</template>

<script>
import CarrierService from '@/services/odoo/CarrierService';

export default {
  props: {
    label: String,
    highlights: [Array],
    disabled: [Boolean],
  },

  data() {
    return {
      items: [],
      isLoading: true,
      erroMessage: null,
    };
  },

  created() {
    this._carrierService = new CarrierService();

    this._carrierService
      .findAllCarrierView()
      .then((resp) => {
        this.items = resp.data;
        this.isLoading = false;
      })
      .catch((error) => {
        this.erroMessage = `Server Error: ${error.response.statusText}`;
        this.isLoading = false;
      });
  },

  methods: {
    onChange(value) {
      this.$emit('update:carrierId', value);
    },

    highlightClass(item) {
      if (this.highlights) {
        if (this.highlights.find((i) => i == item.id)) return 'highlight';
      }
      return '';
    },
  },
};
</script>

<style scoped>
.highlight {
  background-color: var(--v-blue-base);
}
</style>
